module.exports = __webpack_public_path__ + "static/media/64 - Les Sins - Grind.74e88167.mp3";